import Vue from 'vue'
import VueRouter from 'vue-router'
// Views
import HomeView from '../views/Home'
import AboutView from '../views/About'
//
import WidgetView from '../views/Widget'
import WidgetsView from '../views/Widgets'
import E404View from '../views/404.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView
  },
  {
    path: '/widgets',
    name: 'widgets',
    component: WidgetsView
  },
  {
    path: '/widgets/widget',
    name: 'widget',
    component: WidgetView
  },
  {
    path: '/countries/:countryCode',
    name: 'Country',
    beforeEnter: (to, from, next) => to.params.countryCode.length === 2 ? next() : next(false)
  },
  {
    path: '*',
    name: 'E404',
    component: E404View
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
